import {createTheme} from '@mui/material';

const primaryColor = '#15216d';
const whiteColor = '#fff';
const gray3Color = '#333';
const gray5Color = '#555';
const grayF8Color = '#f8f8fb';
const textSecondary = '#a30014';
const purple1Color = '#9E009E';
const purple2Color = '#EAD7EA';

// Buttons
const primaryButtonColor = primaryColor;
const primaryButtonHoverColor = '#4a538e';

const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor
    },
    secondary: {
      main: gray5Color
    }
  },
  typography: {
    fontFamily: 'Open Sans'
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: 'Open Sans',
          fontSize: '14px'
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: 'Open Sans',
          fontSize: '14px'
        }
      }
    },
    MuiFormGroup: {
      styleOverrides: {
        root: {
          '&:not(:last-child)': {
            marginBottom: '20px'
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          'fontFamily': 'Open Sans',
          'fontSize': '14px',
          '&.Mui-focused': {
            'color': purple1Color
          }
        },
        shrink: {
          background: `linear-gradient(0deg, ${grayF8Color} 30%, transparent 0)`
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&:hover': {
            'backgroundColor': purple2Color
          },
          '@media (hover: none)': {
            '&:hover': {
              'backgroundColor': 'transparent'
            }
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          'width': 'inherit',
          'backgroundColor': grayF8Color,
          'fontSize': '14px',
          'fontFamily': 'Open Sans',
          '&.MuiOutlinedInput-root:hover fieldset': {
            borderColor: purple1Color
          },
          '&.MuiOutlinedInput-root.Mui-disabled:hover fieldset': {
            borderColor: 'rgba(0, 0, 0, .26)'
          },
          '&.MuiOutlinedInput-root.Mui-focused fieldset': {
            'borderColor': purple1Color,
            'zIndex': 10,
            '& span': {
              visibility: 'visible',
              opacity: '0'
            }
          }
        },
        input: {
          '&.MuiOutlinedInput-input:-webkit-autofill': {
            'WebkitBoxShadow': `0 0 0px 1000px ${grayF8Color} inset`
          }
        },
        inputSizeSmall: {
          'padding': '8.5px 14px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          width: '100%'
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          width: '100%'
        },
        inputRoot: {
          padding: '7px 9px'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans',
          fontSize: '14px',
          fontWeight: 600,
          textTransform: 'none'
        },
        sizeSmall: {
          fontSize: '12px'
        },
        containedPrimary: {
          'backgroundColor': primaryButtonColor,
          '&:hover': {
            backgroundColor: primaryButtonHoverColor
          }
        },
        outlinedSecondary: {
          'backgroundColor': whiteColor,
          'border': `1px solid ${gray5Color}`,
          'color': gray3Color,
          '&:hover': {
            'backgroundColor': '#f2f2f2'
          }
        },
        textSecondary: {
          'color': textSecondary
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          'color': purple1Color,
          'margin': '0 7px 0 0',
          '&:hover': {
            'backgroundColor': purple2Color
          },
          '&.Mui-checked:not(.Mui-disabled)': {
            color: purple1Color
          },
          '&.Mui-disabled:not(.Mui-checked)': {
            color: purple2Color
          },
          '@media (hover: none)': {
            '&:hover': {
              'backgroundColor': 'transparent'
            }
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: purple1Color
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          'fontFamily': 'Open Sans',
          'textTransform': 'none',
          'fontWeight': 'bold',
          '&.Mui-selected': {
            'color': purple1Color
          },
          '&:hover': {
            'backgroundColor': purple2Color
          }
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.PrivateDateTimePickerToolbar-penIcon': {
            'display': 'none'
          },
          '@media (hover: none)': {
            '&.icon-button.blue:hover': {
              'backgroundColor': 'transparent'
            }
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '.PrivatePickersSlideTransition-root': {
            'minHeight': '230px'
          },
          '.PrivatePickersToolbar-dateTitleContainer .MuiTypography-h3': {
            'fontSize': '34px'
          },
          '.MuiDialogActions-root': {
            'padding': '2px 8px'
          }
        }
      }
    }
  }
});

export {theme};
